/**
 * Created by bcole on 10/10/17.
 */
import React from 'react'

export default class IconClipboard extends React.Component {

    render() {

        return (
            <svg id="icon-clipboard" viewBox="0 0 32 32" fill="currentColor" className={this.props.className}>
                <title>clipboard</title>
                <path
                    d="M26 32h-20c-1.105 0-2-0.894-2-1.996v-25.014c0-1.103 0.895-1.996 2-1.996h6v1.996h-5c-0.552 0-1 0.446-1 0.998v23.018c0 0.551 0.448 0.998 1 0.998h18c0.553 0 1-0.447 1-0.998v-23.018c0-0.552-0.447-0.998-1-0.998h-5v-1.996h6c1.104 0 2 0.894 2 1.996v25.014c0 1.102-0.896 1.996-2 1.996zM25 5.988v23.018h-18v-23.018h1v4.055h16v-4.055h1zM11 13.037h-1v0.998h1v-0.998zM11 15.033h-1v0.998h1v-0.998zM11 17.029h-1v0.998h1v-0.998zM11 19.025h-1v0.998h1v-0.998zM11 21.021h-1v0.998h1v-0.998zM11 23.018h-1v0.998h1v-0.998zM11 25.014h-1v0.998h1v-0.998zM22 13.037h-10v0.998h10v-0.998zM22 15.033h-10v0.998h10v-0.998zM22 17.029h-10v0.998h10v-0.998zM22 19.025h-10v0.998h10v-0.998zM22 21.021h-10v0.998h10v-0.998zM22 23.018h-10v0.998h10v-0.998zM22 25.014h-10v0.998h10v-0.998zM22 5.988c0.553 0 1 0.446 1 0.998 0 0.551 0 1.996 0 1.996h-14c0 0 0-1.445 0-1.996s0.447-0.998 1-0.998h3c0 0 0.012-1.274 0.012-2.896 0-1.684 1.3-3.092 2.988-3.092s3.033 1.48 3.033 3.103c0 1.746-0.033 2.885-0.033 2.885h3zM16 2.994c-0.553 0-1 0.446-1 0.998s0.447 0.998 1 0.998 1-0.447 1-0.998c0-0.552-0.447-0.998-1-0.998z"></path>
            </svg>
        )
    }
}